import { Phone, MapPin } from "lucide-react";

const LOGO_STACKED = "https://customer-assets.emergentagent.com/job_tpl-roofing/artifacts/x4oygmg8_LOGO.webp";

const FOOTER_LINKS = [
  { label: "Accueil", href: "#accueil" },
  { label: "À propos", href: "#a-propos" },
  { label: "Secteurs", href: "#secteurs" },
  { label: "Réalisations", href: "#realisations" },
  { label: "Contact", href: "#contact" },
];

const SECTORS = [
  "Commercial",
  "Industriel",
  "Institutionnel",
  "Santé",
  "Résidentiel",
];

export default function Footer() {
  const scrollTo = (e, href) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer data-testid="footer" className="bg-[#0A0F1C] text-white">
      {/* Main footer */}
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-28">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
          {/* Brand */}
          <div className="lg:col-span-1">
            <img
              src={LOGO_STACKED}
              alt="TPL inc"
              className="w-32 mb-6 opacity-80"
            />
            <p className="text-white/40 text-sm leading-relaxed max-w-xs">
              Votre partenaire de confiance en toiture et imperméabilisation au Québec.
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="text-sm uppercase tracking-[0.2em] font-bold text-white/50 mb-6">
              Navigation
            </h4>
            <ul className="space-y-3">
              {FOOTER_LINKS.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    onClick={(e) => scrollTo(e, link.href)}
                    data-testid={`footer-link-${link.label.toLowerCase().replace(/\s/g, '-')}`}
                    className="text-white/60 hover:text-white transition-colors text-sm"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Sectors */}
          <div>
            <h4 className="text-sm uppercase tracking-[0.2em] font-bold text-white/50 mb-6">
              Secteurs
            </h4>
            <ul className="space-y-3">
              {SECTORS.map((sector) => (
                <li key={sector}>
                  <span className="text-white/60 text-sm">{sector}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm uppercase tracking-[0.2em] font-bold text-white/50 mb-6">
              Contact
            </h4>
            <div className="space-y-4">
              <a
                href="tel:5147176662"
                data-testid="footer-phone"
                className="flex items-center gap-3 text-white/60 hover:text-white transition-colors"
              >
                <Phone className="w-4 h-4" />
                <span className="text-sm">514-717-6662</span>
              </a>
              <div className="flex items-start gap-3 text-white/60">
                <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0" />
                <span className="text-sm">
                  3361 Rue Chénier 101
                  <br />
                  Mirabel, QC
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Copyright bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p data-testid="footer-copyright" className="text-white/30 text-xs">
            &copy; {new Date().getFullYear()} Toitures & Imperméabilisations TPL inc. Tous droits réservés.
          </p>
          <p className="text-white/20 text-xs">
            Mirabel, Québec, Canada
          </p>
        </div>
      </div>
    </footer>
  );
}
